import store from "../redux/store"
import { setIsLoadingApi } from "../redux/actions"

export const uploadLoadingState = (newState) => {
  store.dispatch(setIsLoadingApi({isLoadingApi: newState}));
}